module.exports = __webpack_public_path__ + "static/media/10.344d6146.jpg";